export default __webpack_public_path__ + "static/media/screw3.be324600.png";